import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { deepExtract } from 'helpers/deep';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { StarRating } from 'components/StarRating/StarRating';
export var MAX_SHOWABLE_VENUES = 20;
export var MIN_SHOWABLE_VENUES = 6;
export var VerticalVenueList =
/*#__PURE__*/
function (_Component) {
  _inherits(VerticalVenueList, _Component);

  function VerticalVenueList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VerticalVenueList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VerticalVenueList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showMaxNumItems: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoadMore", function () {
      _this.setState({
        showMaxNumItems: true
      });
    });

    _this.renderVenueItem = _this.renderVenueItem.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VerticalVenueList, [{
    key: "renderVenueItem",
    value: function renderVenueItem(element) {
      var showCount = this.props.showCount;
      var imgUrl = deepExtract('images.default', element);
      var locationName = deepExtract('location.name', element);
      var ratingMean = deepExtract('ratings.mean', element);
      var hasRating = ratingMean > 0;
      var activities = deepExtract('activities', element);
      var ratingCount = deepExtract('ratings.display_total', element);
      return React.createElement("li", {
        className: "mb",
        key: element.id
      }, React.createElement("a", {
        href: "/studios/".concat(element.alias)
      }, React.createElement(Section, {
        className: "vertical-venue-list__item"
      }, React.createElement("div", {
        className: "vertical-venue-list__item__image",
        style: {
          backgroundImage: "url(".concat(imgUrl, ")")
        }
      }), React.createElement("div", {
        className: "vertical-venue-list__item__content"
      }, React.createElement(Heading, {
        className: "vertical-venue-list__item__title"
      }, element.name), hasRating && React.createElement(StarRating, {
        showRatingNumber: !showCount,
        rating: ratingMean,
        count: showCount && ratingCount && "".concat(ratingCount, " ratings")
      }), locationName && React.createElement("p", {
        className: "vertical-venue-list__item__content__location mb-"
      }, locationName), activities && React.createElement("p", {
        className: "vertical-venue-list__item__content__activities text--light"
      }, activities.split(',')[0].trim())))));
    }
  }, {
    key: "render",
    value: function render() {
      var elements = this.props.elements;
      var showMaxNumItems = this.state.showMaxNumItems;
      var numItems = showMaxNumItems ? MAX_SHOWABLE_VENUES : MIN_SHOWABLE_VENUES;
      var canShowLoadMore = !showMaxNumItems && elements.length > MIN_SHOWABLE_VENUES;
      return React.createElement("div", {
        className: "vertical-venue-list"
      }, React.createElement("ul", null, (elements || []).slice(0, numItems).map(this.renderVenueItem)), canShowLoadMore && React.createElement("div", {
        className: "vertical-venue-list__load-more",
        onClick: this.handleLoadMore
      }, React.createElement(FormattedMessage, {
        id: "vertical-venue-list.load.more",
        defaultMessage: "Load more"
      })));
    }
  }]);

  return VerticalVenueList;
}(Component);
VerticalVenueList.propTypes = {
  elements: PropTypes.array,
  showCount: PropTypes.bool
};